/** Foundation · Copy — anteprima: giornate copiate, sovrascritte, conflitti. */
import React from "react";

const fmtList = (items, formatDate) => items.map((i) => formatDate(i.target)).join(", ");

export function CopyPlanSummary({ plan, error, formatDate = (d) => d }) {
  if (error) return <div className="rounded-md bg-red-50 px-3 py-2 text-xs text-suite-error" data-testid="copy-from-error">{error}</div>;
  if (!plan) return <div className="h-14 animate-pulse rounded-md bg-suite-neutral-50" />;
  const c = plan.counts;
  const overwritten = plan.items.filter((i) => i.action === "overwrite");
  const conflicts = plan.items.filter((i) => i.conflict && i.action !== "none");
  return (
    <div className="space-y-1.5 rounded-md border border-suite-neutral-200 bg-suite-neutral-50/60 px-3 py-2.5 text-xs" data-testid="copy-from-summary">
      <div className="flex flex-wrap gap-x-4 gap-y-1">
        <span data-testid="copy-from-count-copy"><b>{plan.changes.length}</b> giornate verranno copiate</span>
        <span className={overwritten.length ? "text-amber-700" : "text-suite-neutral-500"} data-testid="copy-from-count-overwrite"><b>{overwritten.length}</b> sovrascritte</span>
        {!!c.kept && <span className="text-suite-neutral-500" data-testid="copy-from-count-kept">{c.kept} già compilate lasciate invariate</span>}
        {!!c.none && <span className="text-suite-neutral-400">{c.none} senza orari nell&apos;origine</span>}
      </div>
      {!!overwritten.length && <div className="text-amber-700">Sovrascritte: {fmtList(overwritten, formatDate)}</div>}
      {!!conflicts.length && (
        <div className="text-suite-error" data-testid="copy-from-conflicts">
          Conflitti: {conflicts.map((i) => `${formatDate(i.target)} (${i.conflict === "blocked" ? "protetta" : i.conflict})`).join(", ")}
        </div>
      )}
    </div>
  );
}

export default CopyPlanSummary;
